import { TVGuideFeedQuery, TVGuideDStvQuery } from '@/types/tvGuide';
import { ValidationError } from './apiError';
import { tvGuideFeedApiResponse, TvGuideFeed } from './validators/tvGuideFeed';
import { isLeft } from 'fp-ts/lib/Either';
import { TvGuideDStv, tvGuideDStvApiResponse, dstvCountryChannelsApiResponse } from './validators/tvGuideDStv';
import { RawApi } from '.';

export interface TvGuideAPI {
  fetchFeedTvGuide: (query: TVGuideFeedQuery) => Promise<TvGuideFeed>;
  fetchDStvTvGuide: (query: TVGuideDStvQuery) => Promise<TvGuideDStv>;
}

export class TvGuideApi extends RawApi implements TvGuideAPI {

  public async fetchFeedTvGuide(
    query: TVGuideFeedQuery,
  ): Promise<TvGuideFeed> {
    const response = await this.fetchFeedApi(`/active-tv-guide/${query.country}/${query.filter}`);
    const jsonResponse: unknown = await response.json();
    const tvGuideFeed = tvGuideFeedApiResponse.decode(jsonResponse);

    if (isLeft(tvGuideFeed)) {
      throw new ValidationError('API Response validation failed', 400, tvGuideFeed);
    }

    return tvGuideFeed.right;
  }

  public async fetchDStvTvGuide(
    query: TVGuideDStvQuery,
  ): Promise<TvGuideDStv> {
    const channelsResponse = await this.fetchDStvApi('/cs-epg/channel/fetchChannelsByCountry', { country: query.country });
    const jsonChannelsResponse: unknown = await channelsResponse.json();
    const countryChannels = dstvCountryChannelsApiResponse.decode(jsonChannelsResponse);

    if (isLeft(countryChannels)) {
      throw new ValidationError('API Response validation failed', 400, countryChannels);
    }

    const supersportChannels = countryChannels.right.items
      .filter((channel) => {
        return channel.streams && (
          channel.channelName.includes('SuperSport')
          || channel.channelName.includes('Ginx')
          || channel.channelName.includes('Community Services Network')
          || channel.channelNumber.includes('123')
        );
      })
      .map((channel) => channel.channelTag);

    const response = await this.fetchDStvApi('/cs-epg/schedule/schedulesByTag', { date: query.date, channelTags: supersportChannels });
    const jsonResponse: unknown = await response.json();
    const tvGuideDStv = tvGuideDStvApiResponse.decode(jsonResponse);

    if (isLeft(tvGuideDStv)) {
      throw new ValidationError('API Response validation failed', 400, tvGuideDStv);
    }

    return tvGuideDStv.right;
  }
}
